import React from 'react';
import { DecisionItem as AkDecisionItem } from '@atlaskit/task-decision';
export default function DecisionItem(_ref) {
  var children = _ref.children,
    dataAttributes = _ref.dataAttributes;
  return /*#__PURE__*/React.createElement(AkDecisionItem, {
    dataAttributes: dataAttributes
  }, children);
}